<form-field
  class="tw-w-full tw-relative"
  label="common.discountCode"
  [(value)]="discountCode"
  classList="tw-text-lg tw-pr-3 font-vazir-ui tw-text-right dir-ltr"
  [isDisabled]="!isAuthenticate"
  (valueChange)="onChangeDiscountCode($event)"
>
  <span prefix-content>
    <i class="text-success mdi mdi-label-percent-outline mdi-24px"></i>
  </span>
  <div content>
    <i
      *ngIf="!result?.discountAmount && discountCode"
      class="clear-icon text-secondary mdi mdi-close-circle mdi-20px tw-mt-3 tw-cursor-pointer"
      (click)="onRemoveDiscountCode()"
    ></i>

    <!--#region submit btn -->
    <button
      *ngIf="!result?.discountAmount"
      (click)="onVerifyDiscountApi()"
      class="tw-flex-center text-primary tw-font-semibold tw-absolute btn-sm tw-mt-1 tw-cursor-pointer tw-w-[55px] tw-h-[30px]"
      [themeColor]="'btn-light-info'"
      style="left: 0; top: 10px; border: unset"
      [disabled]="!isAuthenticate"
    >
      <span *ngIf="!loading" class="text-submit-discount-btn">
        {{ "common.submit" | translate }}
      </span>

      <!-- loading -->
      <ng-container *ngIf="loading" class="tw-px-1">
        <div class="tw-px-1 tw-flex-center">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Loading...</span>
        </div>
      </ng-container>
      <span></span>
    </button>
    <!--#endregion -->

    <!--#region remove discount btn -->
    <div
      *ngIf="result?.discountAmount"
      (click)="onRemoveDiscountVerified()"
      class="tw-flex-center btn-light-danger text-danger tw-font-semibold tw-absolute btn-sm tw-mt-1 tw-cursor-pointer tw-w-[55px] tw-h-[30px]"
      style="left: 0; top: 0"
    >
      {{ "common.delete" | translate }}
    </div>
    <!--#endregion -->
  </div>
</form-field>

<!--#region error state -->
<div
  class="tw-flex tw-justify-start tw-items-center tw-h-[20px]"
  [class.d-none]="!result?.verifyDescription || !discountCode"
>
  <i
    class="mdi mdi-alert-circle-outline mdi-18px text-danger tw-mb-1 tw-mx-1"
  ></i>
  <mat-error
    class="tw-text-[12px] text-dnager tw-font-medium"
    [innerHTML]="result?.verifyDescription"
  >
  </mat-error>
</div>
<!--#endregion -->

<!--#region success state -->
<div
  class="tw-flex tw-justify-start tw-items-center tw-h-[20px]"
  [class.d-none]="!result?.discountAmount"
>
  <i class="mdi mdi-check-bold mdi-18px text-success tw-mb-2 tw-mx-1"></i>
  <span class="tw-text-[12px] text-success tw-font-medium">
    {{ "messages.successfulDiscount" | translate }}
  </span>
</div>
<!--#endregion -->
